<template>
    <div v-if="dataLoaded">
        <button @click="editMode = !editMode">Edit</button>
        
        
        <form v-if="editMode" v-on:submit.prevent>
            <div class="row">
                <div class="column>">
                    <h3>Contact Info</h3>
                    <label>Name</label><input type="text" v-model="contact.name"/>
                    <label>ID</label><input type="number" v-model="contact.id" disabled/>
                    <label>Lead Source</label><input type="text" v-model="contact.lead_source"/>
                    <label>Organization Type</label>
                    <select v-model="contact.type">
                        <option v-for="opt in $store.organization_types" :key="opt.id" :value="opt.id">{{opt.name}}</option>
                    </select>
                
                    <h3>Primary Contact</h3>
                    <label>Name</label><input type="text" v-model="contact.contact_name"/>
                    <label>Email</label><input type="email" v-model="contact.contact_email"/>
                    <label>Landline</label><input type="tel" v-model="contact.contact_landline"/>
                    <label>Mobile</label><input type="tel" v-model="contact.contact_mobile"/>
                </div>

                <div class="column">
                    <h3>Business Details</h3>
                    <label>Name</label><input type="text" v-model="contact.business_name"/>
                    <label>Email</label><input type="email" v-model="contact.business_email"/>
                    <label>Phone</label><input type="tel" v-model="contact.business_landline"/>

                    <h3>Address</h3>
                    <label>Street Address 1 &amp; 2</label>
                    <input type="text" v-model="contact.address1"/> <input type="text" v-model="contact.address2"/>
                    <label>Suburb</label><input type="text" v-model="contact.locality"/>
                    <label>State</label><input type="text" v-model="contact.province"/>
                    <label>Postcode</label><input type="text" v-model="contact.postcode"/>
                    <label>Country</label><input type="text" v-model="contact.country"/>
                </div>
            </div>

            <p><b>Notes</b></p><textarea v-model="contact.notes"></textarea>
            <p><button @click="updateContact">Save</button></p>
        </form>
        
        <div v-if="!editMode">
            <div class="row">
                <div class="column">
                    <p><b>Salesperson</b> <router-link :to="'/users/'+contact.salesperson">{{ contact.authorName }}</router-link></p>
                    <p><b>Lead Source</b> {{ contact.lead_source }}</p>
                    <p :data-type="contact.type"><b>Organization Type</b> {{ contact.orgType }}</p>
                    <p><b>Created </b> {{ contact.created | date }}</p>
                    <p><b>Modified </b> {{ contact.modified | date }}</p>
                    <h3>Notes</h3><p> {{ contact.notes }}</p>
                </div>

                <div class="column">                
                    <h3>Primary Contact: {{ contact.contact_name | truncate(40) }}</h3>
                    <p><a :href="'mailto:'+contact.contact_email">{{ contact.contact_email }}</a></p>
                    <p><a :href="'tel:'+contact.contact_landline">{{ contact.contact_landline }}</a></p>
                    <p><a :href="'tel:'+contact.contact_mobile">{{ contact.contact_mobile }}</a></p>
                
                    <h3>Business: {{ contact.business_name | truncate(40) }}</h3>
                    <p><a :href="'mailto:'+contact.business_email">{{ contact.business_email }}</a></p>
                    <p><a :href="'tel:'+contact.business_landline">{{ contact.business_landline }}</a></p>

                    <p>{{ contact.address1 }}</p><p>{{contact.address2 }} {{contact.locality }},</p><p> {{contact.province }} {{contact.postcode }}, {{contact.country }}</p>
                </div>
            </div>
            <h3>Projects...</h3>
            <table v-if="projects.length">
                <tr>
                    <th>Project</th>
                    <th>Rating</th>
                    <th>Created</th>
                    <th>Sales Stage</th>
                </tr>
                <tr v-for="p in projects" :key="p.id">
                    <td><router-link :to="('/projects/'+p.id)">{{ p.name | truncate(40) }}</router-link></td>
                    <td>{{ p.rating | capitalize }} </td>
                    <td>{{ p.created | date }}</td>
                    <td>{{ p.salesstageName }}</td>
                </tr>
            </table>
            <p v-if="projects.length == 0">This Contact has no associated Projects</p>
        </div>
    </div>
</template>

<script>
import {CallApi} from '../Utilities.js'

export default {
    name: 'OrganizationDetail',
    watch: {
        '$route': 'fetchData'
    },
    data: function() {
        return {    
            editMode: false,
            dataLoaded: false,
            contact: {},
            projects: {},
        }
    },
    methods: {
        fetchData: async function() {
            const apiResponse =  await CallApi('GET', `/organizations/${this.$route.params.id}`)
            this.contact  = apiResponse.contact
            this.projects = apiResponse.projects
            this.dataLoaded = true
            this.editMode = false
        },
        updateContact: async function() {
            // Do Update
            await CallApi("POST", `/organizations/${this.contact.id}`, this.contact)
            
            // Retrieve Updated Data
            this.fetchData()
        }
    },
    mounted() { this.fetchData() }
}
</script>